import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d30c1782"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"1.5rem"},
  class: "pi pi-lock"
}, null, -1))
const _hoisted_2 = { class: "p-inputgroup" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" })
], -1))
const _hoisted_4 = { class: "p-inputgroup p-my-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" })
], -1))
const _hoisted_6 = { class: "p-pl-2 p-ml-2 p-mt-0" }
const _hoisted_7 = { class: "p-inputgroup" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)), ["prevent"])),
    autocomplete: "off"
  }, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("workspaceLayout.security")), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            type: "password",
            modelValue: _ctx.form.currentPassword.$value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.currentPassword.$value) = $event)),
            placeholder: _ctx.$t('signUp.current'),
            class: _normalizeClass({ 'p-invalid': _ctx.form.currentPassword.$hasError }),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.currentPassword.$validate()))
          }, null, 8, ["modelValue", "placeholder", "class"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Password, {
            modelValue: _ctx.form.newPassword.$value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.newPassword.$value) = $event)),
            class: _normalizeClass({ 'p-invalid': _ctx.form.newPassword.$hasError }),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.newPassword.$validate())),
            placeholder: _ctx.$t('signUp.password')
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_Divider, { style: {"background":"gainsboro","height":"1px"} }),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('validation.validPassword'), (m, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(m), 1))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "class", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_InputText, {
            type: "password",
            modelValue: _ctx.form.confirm.$value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.confirm.$value) = $event)),
            placeholder: _ctx.$t('signUp.confirm'),
            class: _normalizeClass({ 'p-invalid': _ctx.form.confirm.$hasError }),
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.confirm.$validate()))
          }, null, 8, ["modelValue", "placeholder", "class"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          disabled: _ctx.hasError,
          loading: _ctx.loading,
          class: "p-button-outlined p-button-success",
          icon: "pi pi-save",
          label: _ctx.$t('save'),
          type: "submit"
        }, null, 8, ["disabled", "loading", "label"])
      ]),
      _: 1
    })
  ], 32))
}